// @flow

// C0002 = Performance/Analytics, C0004 = Targeting.
const TRACKING_CONSENT_CATEGORIES = ['C0002'];

const CONSENT_CHANGED_EVENT = 'oneTrustConsentChanged';

const hasConsentCookie = (): boolean =>
    document.cookie.indexOf('OptanonAlertBoxClosed') !== -1;

export const hasTrackingConsent = (): boolean => {
    if (!hasConsentCookie()) {
        return false;
    }
    const activeGroups: string = window.OnetrustActiveGroups || '';
    return TRACKING_CONSENT_CATEGORIES.every((category: any) =>
        activeGroups.includes(category)
    );
};

export const onConsentChange = (callback: () => void): (() => void) => {
    const handler = () => callback();
    window.addEventListener(CONSENT_CHANGED_EVENT, handler);

    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
};

export const loadOnConsent = (loader: () => void): void => {
    if (hasTrackingConsent()) {
        loader();
        return;
    }

    const cleanup = onConsentChange(() => {
        if (hasTrackingConsent()) {
            loader();
            cleanup();
        }
    });
};

export const listenForSegmentRevocation = (): void => {
    onConsentChange(() => {
        if (!hasTrackingConsent() && window.analytics) {
            window.analytics.reset();
        }
    });
};
